export default {
	"exceptcreate": {
		"getFileLable": "自动获取相关照片/附件"
	},
	"exceptdeal": {
		"batchRe": "重新处理",
		"exceptionStatus": "异常状态",
		"handlePerson": "处理人",
		"exceptionGrade": "异常级别",
		"exceptionReason": "异常原因",
		"overdueTime": "处理逾期时间",
		"exceptionFinish": "处理完成",
		"exceptionInfo": "异常信息",
		"slight": "轻微",
		"serious": "严重",
		"losingPartner": "责任方",
		"our": "我方",
		"other": "对方",
		"compensation": "赔付金额(元)",
		"tips": "责任人(回车可直接录入)",
		"tips1": "请输入责任人",
		"executDescription": "处理说明",
		"exceptionDescription": "异常说明",
		"tips2": "请选择一个状态是 已处理或关闭 的数据行",
		"tips3": "状态必须是已处理或关闭，才能重新处理。",
		"tisp4": "确定要重新处理吗",
		"tisp5": "请先保存，再确认",
		"tisp6": "异常状态必须为新建",
		"exceptionExecuteLable": "责任界定",
		"exceptdealTitle": "处理异常",
		"cancelDeal": "已取消重新处理"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/except/except.js